import React from 'react';
import { printables } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Gallery() {
  return <section id="inside" aria-labelledby="inside-title" className="bg-cream" data-id="element-120" data-mp="3ic7q8y1av6qu">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-121" data-mp="3ia52kknmdppa">
        <SectionHeading id="inside-title" title="See What’s Inside" intro="A few of the 20+ design styles. Every printable carries its own Gospel message — 200+ in all, none repeated." data-id="element-122" data-mp="3ddo52zuj5yzj" />
        <ul className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-6" data-id="element-123" data-mp="2kme9wxzf4i0l">
          {printables.map(p => <li key={p.id} className={p.wide ? 'sm:col-span-2 lg:col-span-4' : 'sm:col-span-1 lg:col-span-2'} data-id="element-124" data-mp="2umwzm9dnysqf">
              <figure className="flex h-full items-center justify-center rounded-xl bg-white p-4 shadow-card ring-1 ring-cream-line sm:p-6 lg:h-[250px]" data-id="element-125" data-mp="26wj3o7ryk9qk">
                <img src={p.src} alt={p.alt} loading="lazy" className="h-auto max-h-full w-auto max-w-full" data-id="element-126" data-mp="21xpsim058utk" />
              </figure>
            </li>)}
        </ul>
        <div className="mt-12 flex flex-col items-center gap-4 text-center" data-id="element-127" data-mp="wacsmz6cl2us">
          <p className="font-display text-2xl text-navy" data-id="element-128" data-mp="11249ghzpbu7q">…and many more styles waiting inside.</p>
          <CtaButton data-id="element-129" data-mp="1547n9d9ufaw6">Get Access Now</CtaButton>
        </div>
      </div>
    </section>;
}